const sign = {"1": "+", "-1": "-"};
const spinFrac = {
    0: "0",
    1: "\\frac{1}{2}",
    2: "1",
    3: "\\frac{3}{2}",
    4: "2",
    5: "\\frac{5}{2}",
    6: "3",
    7: "\\frac{7}{2}",
    8: "4",
    9: "\\frac{9}{2}",
    10: "5",
    11: "\\frac{11}{2}",
    12: "6"
}


const get_jp = (j, p) => {
    return "`" + spinFrac[j] + "^{"+sign[p]+"}`";
}

export default get_jp;